import * as Types from '@/types/productivity-schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql-productivity';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type P_UserWorkspacesQueryVariables = Types.Exact<{
  personId: Types.Scalars['ID']['input'];
}>;


export type P_UserWorkspacesQuery = { userWorkspaces: { lastWorkspaceId?: string | null, workspaces: Array<{ id: string, entityId?: string | null, displayName?: string | null }> } };


export const P_UserWorkspacesDocument = /*#__PURE__*/ gql`
    query p_UserWorkspaces($personId: ID!) {
  userWorkspaces(personId: $personId) {
    workspaces {
      id
      entityId
      displayName
    }
    lastWorkspaceId
  }
}
    `;

export function useP_UserWorkspacesQuery(options: Omit<Urql.UseQueryArgs<P_UserWorkspacesQueryVariables>, 'query'>) {
  return Urql.useQuery<P_UserWorkspacesQuery, P_UserWorkspacesQueryVariables>({ query: P_UserWorkspacesDocument, ...options });
};